import { useEffect, useRef, useState } from "react";

export function useAutoFillColumns(table) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // measure container dynamically
  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new ResizeObserver(([entry]) => {
      setContainerWidth(entry.contentRect.width);
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  // compute total column size
  const totalSize = table
    .getAllLeafColumns()
    .reduce((sum, col) => sum + col.getSize(), 0);

  const shouldStretch = containerWidth > 0 && totalSize < containerWidth;

  // helper to get column style
  const getColStyle = (column) => {
    const colSize = column.getSize();
    return {
      width: shouldStretch
        ? `${(colSize / totalSize) * 100}%`
        : `${colSize}px`,
    };
  };

  return { containerRef, shouldStretch, getColStyle };
}
